import { BulkPostDatingJobStatus } from '@dealstack/shared/lib/backendClient';
// From shared, not the gitignored generated client, so a new backend reason fails this Record
// on a fresh checkout rather than only once CI regenerates.
import { PostDatingSkipReason } from '@dealstack/shared/lib/common/postDating/skipReason';
import type { BulkApplyDateDto } from '@dealstack/shared/lib/backendClient';

export const BULK_APPLY_DATE_TERMINAL_STATUSES: readonly BulkPostDatingJobStatus[] = [
	BulkPostDatingJobStatus.COMPLETED,
	BulkPostDatingJobStatus.FAILED,
];

export type BulkApplyDateSelection = Omit<BulkApplyDateDto, 'effectiveDate'>;

/** The enum's value union: the generated client's string union is not assignable to the TS enum. */
export type SkipReasonValue = `${PostDatingSkipReason}`;

export interface SkippedReasonBucket {
	reason: SkipReasonValue;
	count: number;
}

/**
 * Every `PostDatingSkipReason` mapped to its Tolgee key. A `Record` over the enum means a new
 * reason fails the type-check here instead of silently rendering a blank row.
 */
export const BULK_APPLY_DATE_SKIP_REASON_KEYS: Record<SkipReasonValue, string> = {
	[PostDatingSkipReason.NOT_FOUND]: 'documents_page.bulk_apply_date_modal.skip_reason.not_found',
	[PostDatingSkipReason.NOT_COMPLETED]:
		'documents_page.bulk_apply_date_modal.skip_reason.not_completed',
	[PostDatingSkipReason.NOT_POST_DATED]:
		'documents_page.bulk_apply_date_modal.skip_reason.not_post_dated',
	[PostDatingSkipReason.NOT_EID_EASY]:
		'documents_page.bulk_apply_date_modal.skip_reason.not_eid_easy',
	[PostDatingSkipReason.ALREADY_DATED]:
		'documents_page.bulk_apply_date_modal.skip_reason.already_dated',
	[PostDatingSkipReason.NO_PLACEMENTS]:
		'documents_page.bulk_apply_date_modal.skip_reason.no_placements',
	[PostDatingSkipReason.DIFFERENT_DATE]:
		'documents_page.bulk_apply_date_modal.skip_reason.different_date',
	[PostDatingSkipReason.UNSIGNED_FILE]:
		'documents_page.bulk_apply_date_modal.skip_reason.unsigned_file',
	[PostDatingSkipReason.NO_RESOLVED_POSITION]:
		'documents_page.bulk_apply_date_modal.skip_reason.no_resolved_position',
};
